module.exports = __webpack_public_path__ + "static/media/400095_01.20fc09a5.png";